import { atom } from 'recoil';

export const studentReportState = atom({
  key: 'studentReportState',
  default: null,
});
